module.exports = __webpack_public_path__ + "2b32061b523a6c512d8ce9641b17cbf2.gif";